import React from "react";
import { useHooks } from "./hooks";

export const YoutoPlugin = React.memo(({ on }: { on: boolean }) => {
  useHooks(on);

  return <></>;
});
